import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import { toast } from "react-toastify";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  useMediaQuery,
  Grid,
  Divider,
  Typography,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { useTheme } from "@mui/material/styles";
import { deleteCustomer } from "../../../../utils/action";
import { setTitleCase } from "app/components/template/partials";
import { STATUS } from "configs/constant";

export function DeleteCustomer() {
  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();
  const [isLoading, setLoading] = useState(false);
  const showDialog = location.state?.showDialog ?? false;
  const customerData = location.state?.customerData ?? null;
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  const handleFormSubmit = async (values) => {
    setLoading(true);

    // send to backend
    try {
      await deleteCustomer(values.id);
      toast.success(setTitleCase("berhasil menghapus data pelanggan"));
    } catch (error) {
      toast.error(setTitleCase(error.response.data?.message));
    }
    setLoading(false);
    onHide();
  };

  const onHide = () => {
    navigate(-1);
  };

  return (
    <Dialog
      fullScreen={fullScreen}
      fullWidth
      open={showDialog}
      onClose={onHide}
      aria-labelledby="responsive-dialog-delete-cutomer-title"
      className="dialog-container"
    >
      <DialogTitle id="responsive-dialog-delete-cutomer-title">
        Hapus Pelanggan
      </DialogTitle>
      <Divider />

      <DialogContent className="dialog-content-column">
        <img
          src="/assets/images/alert.webp"
          width="30%"
          height="30%"
          alt="delete-cutomer images"
          loading="lazy"
        />
        <div className="dialog-content-spacing">
          <Grid container spacing={2} className="dialog-content-text">
            <Grid item md={12} xs={12}>
              <Typography className="dialog-content-key-text">
                NAMA PELANGGAN
              </Typography>
              <Typography gutterBottom className="dialog-content-value-text">
                {customerData?.nama_pelanggan}
              </Typography>
              <Divider />
            </Grid>
            <Grid item md={12} xs={12}>
              <Typography className="dialog-content-key-text">
                NO.TELEPON
              </Typography>
              <Typography gutterBottom className="dialog-content-value-text">
                {customerData?.nomor_hp}
              </Typography>
              <Divider />
            </Grid>
          </Grid>
        </div>
        {customerData?.status !== STATUS.REGISTERED && 
        <div className="dialog-content-spacing">
          <Grid container spacing={2} className="dialog-content-text">
            <Grid item md={12} xs={12}>
              <Typography className="dialog-content-key-text">
                Telah ada Booking pada 
              </Typography>
              <Typography gutterBottom className="dialog-content-value-text">
                {dayjs(customerData.waktu_pembersihan)
                  .locale("id")
                  .format("dddd, DD MMMM YYYY [pukul] HH:mm")}
              </Typography>
              <Divider />
              <Typography className="dialog-content-key-text-2">
                Apabila anda menghapus data pelanggan ini, <br></br>
                Maka otomatis jadwal yang telah dipesan  akan otomatis menjadi tersedia kembali
              </Typography>
            </Grid>
          </Grid>
        </div>}
        <div className="dialog-content-spacing">
          <Typography className="dialog-confirm-text">
            Apakah anda serius untuk menghapus data pelanggan anda ?
          </Typography>
        </div>
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={onHide} color="error" variant="contained">
          Batal
        </Button>
        <LoadingButton
          autoFocus
          loading={isLoading}
          color="primary"
          variant="contained"
          onClick={() => handleFormSubmit(customerData)}
        >
          Simpan
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
}
